import Vue from 'vue';

import { BootstrapVue } from 'bootstrap-vue';

Vue.use(BootstrapVue, {
  "BToast": {
    "appendToast": true,
    "solid": true
  }
});
